export const removeCollisions: <T>(
  input: T[],
  getLeft: (item: T) => number,
  getRight: (item: T) => number
) => T[] = (input, getLeft, getRight) => {
  const indicesToRemove = new Set<number>();
  for (let ii = 0; ii < input.length; ii++) {
    if (indicesToRemove.has(ii)) {
      continue;
    }
    const rightA = getRight(input[ii]);
    for (let jj = ii + 1; jj < input.length; jj++) {
      const leftB = getLeft(input[jj]);
      if (leftB < rightA) {
        indicesToRemove.add(jj);
      }
    }
  }
  return input.filter((_item, index) => !indicesToRemove.has(index));
};
